/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sections/view.blocks to change it.
import ActiveTab from './ActiveTab/index'
import React from 'react'
import Tabs from './Tabs/index'



/** @type {import('Simple/types.js').View} */
export default function Sections({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections"
  
}) {
  return (<React.Fragment
>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<ActiveTab
  viewPath={`${viewPath}/ActiveTab`}
/>
{children}
</React.Fragment>)
}